import React, { useState } from 'react';
import { Instagram, Facebook, Linkedin, MapPin, Phone, Mail, Calendar } from 'lucide-react';
import emailjs from '@emailjs/browser';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
const WHATSAPP_URL = 'https://wa.me/14028720639';
// TODO: Replace with actual EmailJS credentials
const EMAILJS_SERVICE_ID = 'service_doctorecommerce';
const EMAILJS_TEMPLATE_ID = 'template_restaurant_mini';
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';
export function Footer() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const handleMiniSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      if (EMAILJS_PUBLIC_KEY === 'YOUR_PUBLIC_KEY') {
        await new Promise(resolve => setTimeout(resolve, 1000));
        setSubmitStatus('success');
        (e.target as HTMLFormElement).reset();
        setIsSubmitting(false);
        return;
      }
      await emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, e.currentTarget, EMAILJS_PUBLIC_KEY);
      setSubmitStatus('success');
      (e.target as HTMLFormElement).reset();
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <footer className="bg-[#050505] pt-20 pb-8 px-4 border-t border-gray-900" data-id="element-97">
      <div className="max-w-7xl mx-auto" data-id="element-98">
        {/* Top 4 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-99">
          {/* Col 1: About */}
          <div className="space-y-6" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/2wzBsngBkoAKAmxHXDNPHE/IMG_6635.jpg" alt="Doctor Ecommerce" className="h-14 w-auto object-contain" data-id="element-101" />
            <p className="text-gold italic font-medium text-lg" data-id="element-102">
              La cura para negocios estancados.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-103">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            <div className="flex gap-4 pt-2" data-id="element-104">
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-105">
                <Instagram className="w-5 h-5" data-id="element-106" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-107">
                <Facebook className="w-5 h-5" data-id="element-108" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-109">
                <Linkedin className="w-5 h-5" data-id="element-110" />
              </a>
              {/* Custom TikTok icon using SVG since lucide doesn't have a perfect match */}
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-111">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-112">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" data-id="element-113" />
                </svg>
              </a>
            </div>
          </div>

          {/* Col 2: Servicios */}
          <div data-id="element-114">
            <h3 className="text-gold font-bold mb-6 uppercase tracking-wider" data-id="element-115">
              Servicios
            </h3>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-116">
              <li data-id="element-117">Meta Ads · Google Ads · TikTok Ads · YouTube Ads</li>
              <li data-id="element-118">Email · SMS · Retargeting Automatizado</li>
              <li data-id="element-119">Automatización con IA para Ventas 24/7</li>
              <li data-id="element-120">Funnels Quirúrgicos por Industria</li>
              <li data-id="element-121">Blindaje Digital & Anti-Ban</li>
              <li data-id="element-122">PR Digital & Posicionamiento en Medios</li>
              <li data-id="element-123">CRM & Data Tracking Avanzado</li>
              <li data-id="element-124">Video Marketing IA · SEO · Branding</li>
              <li data-id="element-125">Gestión de Reputación · Google Maps</li>
              <li data-id="element-126">Diseño Web · Landing Pages · CRO</li>
            </ul>
          </div>

          {/* Col 3: Recursos */}
          <div data-id="element-127">
            <h3 className="text-gold font-bold mb-6 uppercase tracking-wider" data-id="element-128">
              Recursos
            </h3>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-129">
              <li data-id="element-130">
                <a href="#" className="hover:text-gold transition-colors flex items-center gap-2" data-id="element-131">
                  <span className="text-gray-600" data-id="element-132">›</span> Blog de Estrategia
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="hover:text-gold transition-colors flex items-center gap-2" data-id="element-134">
                  <span className="text-gray-600" data-id="element-135">›</span> Casos de Éxito
                </a>
              </li>
              <li data-id="element-136">
                <a href="#" className="hover:text-gold transition-colors flex items-center gap-2" data-id="element-137">
                  <span className="text-gray-600" data-id="element-138">›</span> Política de
                  Privacidad
                </a>
              </li>
              <li data-id="element-139">
                <a href="#" className="hover:text-gold transition-colors flex items-center gap-2" data-id="element-140">
                  <span className="text-gray-600" data-id="element-141">›</span> Términos y
                  Condiciones
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Contacto Directo */}
          <div className="space-y-6" data-id="element-142">
            <h3 className="text-gold font-bold mb-6 uppercase tracking-wider" data-id="element-143">
              Contacto Directo
            </h3>
            <ul className="space-y-4 text-sm text-gray-300" data-id="element-144">
              <li className="flex items-start gap-3" data-id="element-145">
                <MapPin className="w-5 h-5 text-gold shrink-0" data-id="element-146" />
                <span data-id="element-147">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-148">
                <Phone className="w-5 h-5 text-gold shrink-0" data-id="element-149" />
                <span data-id="element-150">402-872-0639</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-151">
                <Mail className="w-5 h-5 text-gold shrink-0" data-id="element-152" />
                <span data-id="element-153">doctor.ecommerceus@gmail.com</span>
              </li>
            </ul>

            <div className="pt-4 space-y-3" data-id="element-154">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold py-3 px-4 rounded-sm transition-colors" data-id="element-155">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-156">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" data-id="element-157" />
                </svg>
                Habla con un Especialista
              </a>
              <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2 bg-gold hover:bg-[#d9a404] text-carbon font-bold py-3 px-4 rounded-sm transition-colors" data-id="element-158">
                <Calendar className="w-5 h-5" data-id="element-159" />
                RESERVAR DIAGNÓSTICO
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar: Partners & Mini Form */}
        <div className="border-t border-gray-900 pt-12 pb-8 flex flex-col lg:flex-row gap-12 justify-between items-start lg:items-center" data-id="element-160">
          {/* Partners */}
          <div className="w-full lg:w-auto" data-id="element-161">
            <h4 className="text-gray-500 text-xs font-bold tracking-widest uppercase mb-4" data-id="element-162">
              Partners Certificados y Tecnología de Élite
            </h4>
            <div className="flex flex-wrap gap-3" data-id="element-163">
              <div className="bg-white px-3 py-2 rounded-sm flex items-center justify-center h-10 w-24" data-id="element-164">
                <span className="text-black font-bold text-xs" data-id="element-165">Meta</span>
              </div>
              <div className="bg-white px-3 py-2 rounded-sm flex items-center justify-center h-10 w-24" data-id="element-166">
                <span className="text-black font-bold text-xs" data-id="element-167">Google Ads</span>
              </div>
              <div className="bg-white px-3 py-2 rounded-sm flex items-center justify-center h-10 w-24" data-id="element-168">
                <span className="text-black font-bold text-xs" data-id="element-169">HubSpot</span>
              </div>
              <div className="bg-white px-3 py-2 rounded-sm flex items-center justify-center h-10 w-24" data-id="element-170">
                <span className="text-black font-bold text-xs" data-id="element-171">Shopify</span>
              </div>
            </div>
          </div>

          {/* Mini Form */}
          <div className="w-full lg:flex-1 lg:max-w-3xl" data-id="element-172">
            <h4 className="text-gray-500 text-xs font-bold tracking-widest uppercase mb-4" data-id="element-173">
              ¿Quieres que te contactemos?
            </h4>
            <form onSubmit={handleMiniSubmit} className="flex flex-col sm:flex-row gap-3" data-id="element-174">
              <input required type="text" name="nombre" placeholder="Tu Nombre" className="flex-1 bg-transparent border border-gray-800 text-white placeholder-gray-600 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-2 text-sm outline-none" data-id="element-175" />
              <input required type="email" name="email" placeholder="Tu Email" className="flex-1 bg-transparent border border-gray-800 text-white placeholder-gray-600 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-2 text-sm outline-none" data-id="element-176" />
              <input required type="tel" name="telefono" placeholder="Tu Teléfono" className="flex-1 bg-transparent border border-gray-800 text-white placeholder-gray-600 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-2 text-sm outline-none" data-id="element-177" />
              <input required type="text" name="empresa" placeholder="Nombre de tu Empresa" className="flex-1 bg-transparent border border-gray-800 text-white placeholder-gray-600 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-2 text-sm outline-none" data-id="element-178" />
              <button type="submit" disabled={isSubmitting} className="bg-gold hover:bg-[#d9a404] text-carbon font-bold px-6 py-2 rounded-sm text-sm whitespace-nowrap disabled:opacity-70" data-id="element-179">
                {isSubmitting ? '...' : 'ENVIAR'}
              </button>
            </form>
            {submitStatus === 'success' && <p className="text-emerald text-xs mt-2" data-id="element-180">¡Mensaje enviado!</p>}
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-600 text-xs pt-8 border-t border-gray-900" data-id="element-181">
          © {new Date().getFullYear()} Doctor Ecommerce. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}